/* eslint-disable indent */
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  type ChartOptions,
  type Plugin,
  type TooltipItem,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

Chart.register(ArcElement, Tooltip, Legend);


interface PiechartProps {
  data?: number[];
  labels?: string[];
//   [key: string]: any;
}


const defaultLabels = ['0–15 days', '16–30 days', '31–45 days', '>45 days'];
const defaultValues = [10, 60, 18, 12];

// Center text plugin draws the small title and doesn't overlap tooltips
const centerPlugin: Plugin<'doughnut'> = {
  id: 'centerPlugin',
  beforeDraw: (chart) => {
    const ctx = chart.ctx;
    const area = chart.chartArea;
    if (!area) return;

    ctx.save();
    ctx.restore();
  },
};


const getChartData = (labels: string[], values: number[]) => ({
  labels,
  datasets: [
    {
      data: values,
      backgroundColor: ['#6E7280', '#9FA6B8', '#CFD4E0', '#E8EBF5'],
      hoverOffset: 8,
      borderWidth: 0,
    },
  ],
});




const Piechart: React.FC<PiechartProps> = ({ data: propData, labels: propLabels, ...props }) => {
  const labels = propLabels || defaultLabels;
  const values = propData && propData.length > 0 ? propData : defaultValues;
  const total = values.reduce((s, v) => s + v, 0);
  const chartData = getChartData(labels, values);
  const options: ChartOptions<'doughnut'> = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '0%',
  plugins: {
    legend: {
      display: false, // disable built-in legend; we'll render a custom MUI legend above
    },
    tooltip: {
      enabled: true,
      backgroundColor: '#fff',
      titleColor: '#232323',
      bodyColor: '#5a5a5a',
      borderColor: 'rgba(0,0,0,0.08)',
      borderWidth: 1,
      padding: 8,
      usePointStyle: true,
      callbacks: {
        label: (context: TooltipItem<'doughnut'>) => {
          const label = context.label ?? '';
          const value = Number(context.raw ?? 0);
          const percent = total > 0 ? (value / total) * 100 : 0;
          return `${percent.toFixed(1)}%\n(${label})`;
        },
      },
    },
  },
  layout: {
    padding: {
      // keep bottom padding; top spacing will be handled by the custom legend container
      bottom: 50,
    },
  },
};
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }} {...props}>
      
      {/* custom legend to control spacing */}
      <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
        <Box display="flex" alignItems="center" gap={4}>
          {labels.map((lbl, i) => (
            <Box key={lbl} display="flex" alignItems="center" gap={1}>
              <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: chartData.datasets[0].backgroundColor[i] }} />
              <Typography variant="body2" sx={{ color: '#6B6B6B' }}>{lbl}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ width: '100%', height: { xs: 520, md: 640 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ width: { xs: '88%', md: '65%' }, height: { xs: '88%', md: '65%' }, position: 'relative' }}>
          <Doughnut data={chartData} options={options} plugins={[centerPlugin]} />
        </Box>
      </Box>
    </Paper>
  );
};

export default Piechart;
